import { createSelector } from '@reduxjs/toolkit';


export const enrichmentFilterSelector = createSelector(
    (state) => state,
    (state) => state.enrichmentFilter
);
